import { type AuthInfos, authInfosDefaults, UserAccess } from '../models/auth-infos'
import { OTPService, type OTPCode } from './otp.service'
import type { HttpAdapter } from '../../core/adapters/axios.adapter'

/**
 * Custom error thrown when an email address is not found.
 */
export class EmailNotFoundError extends Error {
  constructor(email: string) {
    super(`Email address not found: ${email}`)
    this.name = 'EmailNotFoundError'
  }
}

export class AuthService {
  readonly TBWJF = 'tbw-auth-infos'
  private _authInfos: AuthInfos = authInfosDefaults
  constructor(private _httpAdapter: HttpAdapter, private _otpService: OTPService) { }

  get isAuthenticated() {
    return this._authInfos.userAccess !== UserAccess.Visitor
  }

  get accountType() {
    if (!this.authInfos) { return null }
    return this.authInfos.userAccess
  }

  get authInfos(): AuthInfos {
    return this._authInfos
  }

  get isFreemium(): boolean {
    const freemium = this.authInfos.userAccess === UserAccess.Free
    return this.isAuthenticated && freemium
  }

  get isPremium(): boolean {
    return this.isAuthenticated && (this.authInfos.userAccess === UserAccess.Premium || this.authInfos.userAccess === UserAccess.Founder)
  }

  get isVisitor(): boolean {
    return !this.isAuthenticated
  }

  notify(authenticated: boolean) {
    const customEvent = new CustomEvent('authChange', {
      detail: { authenticated },
      bubbles: true,
      cancelable: true
    });

    document.dispatchEvent(customEvent);
  }

  async sendEmail(email: string) {
    const response = await this._httpAdapter.post('query', { email });
    if (response.status == 404) { throw new EmailNotFoundError('Email not found') }

    return await response.data
  }

  register(token: string) {
    localStorage.setItem(this.TBWJF, token)
  }

  logout() {
    this.clear()
  }

  async verifyOTP(email: string, otpCode: OTPCode) {
    const res = await this._otpService.verifyOTP(email, otpCode)
    if (res) { this.register(res.token) }
    return res
  }

  private clear() {
    this._authInfos = authInfosDefaults;
    localStorage.removeItem(this.TBWJF);
    // this._httpService.clearAuth();
    this.notify(false);
  }

  private getFromStorage(): string | null {
    return localStorage.getItem(this.TBWJF);
  }

  async checkAuth() {
    const token = this.getFromStorage();

    if (!token) {
      this.notify(false);
      return false
    } else {
      // this._httpService.setAuth(token)
    }

    try {
      const response = await this._httpAdapter.get<AuthInfos>('', { headers: { Authorization: `Bearer ${token}` } });
      const authInfos = response.data;
      this._authInfos = authInfos;
      this.notify(true);
      return true;
    } catch (response) {
      console.error('auth check failed', response)
      this.clear();
      return false
    }

    // if (!authInfos.userAccess || !authInfos.userEmail || !authInfos.userAirTableId) {
    //   console.error('invalid authInfos', authInfos)
    //   this.clear();
    //   return false
    // }

  }
}
